import axios from "axios";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Dots } from "react-activity";
import styled from "styled-components";

import { Text } from "@components/Text";
import { COLOR_BLACK, COLOR_WHITE } from "@static/COLORS";
import { formatDuration } from "@utils/formatDuration";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";
import { sleep } from "@utils/sleep";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${COLOR_WHITE};
  border-radius: 6px;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const TableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1.5fr 1fr 0.5fr 0.75fr;
  width: 100%;
  background: #f6f6f6;
  padding: 8px 32px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  box-sizing: border-box;
`;

const ContainerScrollCell = styled.div`
  height: calc(100vh - 260px);
  overflow-y: auto;
  overflow-x: hidden;
`;

const TableCellContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1.5fr 1fr 0.5fr 0.75fr;
  width: 100%;
  padding: 0px 32px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  box-sizing: border-box;
`;

const TableHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  text-align: ${({ align = "start" }) => align};
`;

const TableCell = styled.div`
  font-size: 14px;
  padding: 12px 8px 12px 0px;
  text-align: ${({ align = "start" }) => align};
  word-break: break-all;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: ${COLOR_WHITE};
  border-radius: 6px;
`;

const LABEL_HEADER = [
  "Media Name",
  "Screen Name",
  "Start Date",
  "End Date",
  "Total Duration",
  "Times",
  "Total Days",
];

const { REACT_APP_API_MEDIA_LOG_ENDPOINT } = process.env;

export const TableOverview = ({
  dataList = [],
  setDataList = () => undefined,
  selectedDateRange,
  selectedScreens = null,
  selectedMedia = null,
}) => {
  const allCustomers = getUserExtraCustomers();

  const [isLoading, setIsLoading] = useState(false);
  const initial = async () => {
    try {
      setIsLoading(true);
      const resp = await axios({
        method: "post",
        url: `${REACT_APP_API_MEDIA_LOG_ENDPOINT}/get-overview-media-logs`,
        data: {
          startDate: selectedDateRange[0],
          endDate: selectedDateRange[1],
          deviceId: selectedScreens,
          mediaId: selectedMedia,
          customerList: allCustomers,
        },
      });
      const respData = _.get(resp, ["data"]);
      console.log("respData :>> ", respData);
      if (_.get(respData, ["status"])) {
        const results = _.chain(respData).get(["result"]).value();
        setDataList(results);
      }
      await sleep({ sec: 2 });
    } catch (error) {
      console.log("error :>> ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initial();
  }, []);

  return (
    <Container>
      {!isLoading ? (
        <React.Fragment>
          <TableHeaderContainer>
            {_.map(LABEL_HEADER, (item, index) => {
              const isCenter = _.includes([4, 5, 6], index);
              return (
                <TableHeader key={index} align={isCenter ? "center" : "start"}>
                  {item}
                </TableHeader>
              );
            })}
          </TableHeaderContainer>
          <ContainerScrollCell>
            {_.map(dataList, (item, index) => {
              const rawStartDate = _.get(item, ["start_date"]);
              const sDate = dayjs(rawStartDate).format("DD/MM/YYYY HH:mm:ss");

              const rawEndDate = _.get(item, ["end_date"]);
              const eDate = dayjs(rawEndDate).format("DD/MM/YYYY HH:mm:ss");
              return (
                <TableCellContainer
                  key={index}
                  style={{
                    borderBottom: "1px solid #f6f6f6",
                  }}
                >
                  <TableCell>{_.get(item, ["media_name"])}</TableCell>
                  <TableCell>{_.get(item, ["device_name"])}</TableCell>
                  <TableCell>{sDate}</TableCell>
                  <TableCell>{eDate}</TableCell>
                  <TableCell align="center">
                    {_.get(item, ["total_duration"])}
                  </TableCell>
                  <TableCell align="center">{_.get(item, ["times"])}</TableCell>
                  <TableCell align="center">
                    {_.get(item, ["total_days"])}
                  </TableCell>
                </TableCellContainer>
              );
            })}
          </ContainerScrollCell>
        </React.Fragment>
      ) : (
        <LoadingContainer>
          <Dots />
        </LoadingContainer>
      )}
    </Container>
  );
};
